module.exports = __webpack_public_path__ + "static/img/shsxqwdcy_1.527f83b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/shsxqwdcy_1.jpg
// module id = Ei6I
// module chunks = 15